module.exports = __webpack_public_path__ + "static/media/Logo.4b7821c9.svg";